import * as React from 'react';
import { PipefyUpdateStateProps, PipefyUpdateDispatchProps } from '../../types/containers';

const PipefyUpdateView: React.FC<PipefyUpdateStateProps & PipefyUpdateDispatchProps>
= ({onCancel, onUpdate, pipefyError}) => {
    const content = pipefyError ? <div className="col-12 p-0">
        <div className="text-justify pb-4 text-warning">
            {pipefyError}
        </div>
        <div className="pt-3 pb-2 px-0 text-right border-top">
            <a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
               onClick={onCancel}>Cerrar</a>
        </div>
    </div> : <div className="col-12 p-0">
        <div className="text-justify pb-4">
            Todos los datos se van a sobreescribir en Pipefy
        </div>
        <div className="pt-3 pb-2 px-0 text-right border-top">
            <a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
               onClick={onCancel}>Cancelar</a>
            <a className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0"
               onClick={onUpdate}>Actualizar</a>
        </div>
    </div>;
    return content;
};

export default PipefyUpdateView;